// extracted by mini-css-extract-plugin
export default {"container":"CreatePlaylist_container__iKvJ6","main_frame":"CreatePlaylist_main_frame__UxVJ6","icon":"CreatePlaylist_icon__oU4SE","label":"CreatePlaylist_label__53z6g"};